let config = {}
// const hostname = window.location.hostname

let serverRoot = process.env.VUE_APP_SERVER_ROOT
// if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
//   // اگر روی دستگاه دیگه ای هستی، آدرس رو از hostname کاربر بساز
//   serverRoot = `http://${hostname}:3000`
// }

config.mainWebsiteUrl = process.env.VUE_APP_MAIN_WEBSITE_URL
config.serverRoot = serverRoot
config.socketAddress = process.env.VUE_APP_WEBSOCKET_ADDRESS
config.websocketRoot = process.env.VUE_APP_MAIN_WEBSOCKET_ROOT
// Focused staging follow-up: environment-aware PeerJS signaling host, read
// by VoiceCall.vue instead of a hardcoded production hostname (see
// .env.example's VUE_APP_PEER_ROOT comment and Dockerfile.production).
config.peerRoot = process.env.VUE_APP_PEER_ROOT
config.featureFlagRoot = process.env.VUE_APP_FEATURE_FLAG_ROOT
config.featureFlagClientKey = process.env.VUE_APP_FEATURE_FLAG_CLIENT_KEY
config.devtools = process.env.VUE_APP_DEVTOOLS
config.nodeEnv = process.env.NODE_ENV
config.version = process.env.VUE_APP_VERSION || 'development'
config.sentryEnv = process.env.VUE_APP_SENTRY_ENV
config.sentryDsn = process.env.VUE_APP_SENTRY_DSN
config.customVolunteerPartnerOrgs =
  process.env.SUBWAY_CUSTOM_VOLUNTEER_PARTNER_ORGS || 'bogus'
const customVolunteerPartnerOrgs = config.customVolunteerPartnerOrgs.split(',')
config.customVolunteerPartnerOrgs = customVolunteerPartnerOrgs
config.googleRecaptchaKey = process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY

// Task 11 / STEP-08 (CR-07): discoverability-only. The backend gate
// (config.mobilePhoneAuthEnabled in upchieve-subway) is what is actually
// authoritative -- this flag only controls whether the mobile-first login UI
// is shown. If this is on while the backend gate is off, every /auth/mobile/*
// call fails safely (404) and the UI must handle that as "feature
// unavailable", never as an account-existence signal.
config.mobilePhoneAuthEnabled =
  process.env.VUE_APP_MOBILE_PHONE_AUTH_ENABLED === 'true'

export default config
